import React, { useMemo, useState } from "react";
import Autocomplete from "@/components/Autocomplete";
import { VEHICLE_MAKES, MODELS_BY_MAKE } from "@/lib/vehicleData";

const STATES = ["TAS", "VIC", "NSW", "QLD", "SA", "WA", "NT", "ACT"];

export const AddVehicleForm = ({ onSave, busy }) => {
  const [form, setForm] = useState({ make: "", model: "", year: new Date().getFullYear(), rego: "", state: "TAS" });

  const modelOptions = useMemo(() => {
    const m = (form.make || "").trim();
    const matched = VEHICLE_MAKES.find((mk) => mk.toLowerCase() === m.toLowerCase());
    if (matched && MODELS_BY_MAKE[matched]) return MODELS_BY_MAKE[matched];
    return Array.from(new Set(Object.values(MODELS_BY_MAKE).flat())).sort();
  }, [form.make]);

  return (
    <form data-testid="add-vehicle-form" onSubmit={(e) => { e.preventDefault(); onSave(form); }}
      className="mt-4 border border-zinc-900 bg-zinc-950 p-5 grid grid-cols-2 sm:grid-cols-6 gap-3">
      <div className="col-span-2 sm:col-span-2">
        <Autocomplete testId="garage-make" inputClassName="ta-input" value={form.make}
          onChange={(v) => setForm({ ...form, make: v, model: "" })} options={VEHICLE_MAKES} placeholder="Make" />
      </div>
      <div className="col-span-2 sm:col-span-2">
        <Autocomplete testId="garage-model" inputClassName="ta-input" value={form.model}
          onChange={(v) => setForm({ ...form, model: v })} options={modelOptions} placeholder="Model" />
      </div>
      <input data-testid="garage-year" required type="number" min="1900" max="2099" className="ta-input col-span-1" value={form.year}
        onChange={(e) => setForm({ ...form, year: e.target.value })} placeholder="Year" />
      <input data-testid="garage-rego" className="ta-input col-span-1" value={form.rego}
        onChange={(e) => setForm({ ...form, rego: e.target.value.toUpperCase() })} placeholder="Rego" />
      <select data-testid="garage-state" className="ta-input col-span-1" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })}>
        {STATES.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <button data-testid="garage-save-btn" disabled={busy || !form.make || !form.model}
        className="col-span-1 sm:col-span-1 px-4 py-2 bg-brand-red text-white font-display uppercase text-sm tracking-tight hover:bg-[#B91C2B] disabled:opacity-50">
        {busy ? "…" : "Save"}
      </button>
    </form>
  );
};
